import { matchPath } from 'react-router'

export enum AppRoutes {
  // Login = '/login',
  Dashboard = '/dashboard',
  ContactUs = '/contactUs',
  Terms = '/terms',
  Forgot = '/forgot',
  Privacy = '/privacy',
  FAQs = '/faqs',
  WatchList = '/watchlist',
  ManageBids = '/managebids',
  VDP = '/vehicle/:vehicleInstanceId',
  SearchResult = '/search'
}

const routes = Object.keys(AppRoutes).map((key) => {
  return {
    path: AppRoutes[key],
    name: key
  }
})

export const REACT_ROUTES = routes

export const isReactRoutes = (pathname: string) => {
  if (pathname) {
    const [path] = pathname.split(/[?#]/)
    return REACT_ROUTES.some((item) =>
      matchPath(path, {
        exact: true,
        path: item.path
      })
    )
  }
  return false
}
